/**
 * Rotas do módulo mar.ia no v3.
 *
 * O v2 é a casca (host) e o v3 é remote de Module Federation: o host delega sob o prefixo
 * `/v3/*`, então a rota nasce já com ele. Equivalência com o v2
 * (`mystique/src/modules/maria/routes/index.js`):
 *
 *   v2  /maria/campanha-da-maria            ->  v3  /v3/maria/campanha-da-maria
 *   v2  /maria/campanha-da-maria/nova       ->  v3  /v3/maria/campanha-da-maria/nova
 *   v2  /maria/campanha-da-maria/editar/:id ->  v3  .../editar/:id
 *   v2  /maria/campanha-da-maria/visualizar/:id
 *   v2  /maria/campanha-da-maria/resultados/:id
 *
 * O diretório do submódulo é `campanha-da-maria`, sem o sufixo `-v2` do legado: o
 * `campanha-da-maria/` original foi removido do v2 em `b8c44b0ca` (14/05/2026), então não
 * existe mais um v1 do qual se diferenciar (MK-17442). Carregar a cicatriz para um
 * repositório novo não tem justificativa.
 *
 * ENTREGA PARCIAL (MK-21662): só a rota de RESULTADOS é publicada.
 *
 * As outras quatro (listagem, nova, editar, visualizar) continuam sendo servidas pelo v2 e por isso
 * NÃO são declaradas aqui. Declarar rota do v3 para tela que não vai junto não é inofensivo: como o
 * módulo é registrado inteiro no router (`src/router/index.js`), qualquer uma delas passaria a ser
 * alcançável por URL direta, sem homologação, e apontando para componentes que este corte não traz.
 *
 * Quando o resto da mar.ia for migrado, as quatro voltam para cá e o breadcrumb abaixo deixa de
 * precisar do `onlyAvailableOnVue2`.
 */

const breadcrumbsHome = { name: 'Home', pathName: '/home', onlyAvailableOnVue2: true }
const breadcrumbsMaria = { name: 'mar.ia', pathName: null, action: 'maria' }

/**
 * A listagem CONTINUA NO V2 nesta entrega, então o breadcrumb aponta para lá.
 *
 * `onlyAvailableOnVue2: true` é o que faz o `Breadcrumbs.vue` chamar `$navigateToVue2` em vez de
 * `router.push` (`Breadcrumbs.vue:29-37`). Sem isso o clique empurra `/v3/maria/campanha-da-maria`
 * no router do v3, que nesta entrega não conhece essa rota: como o v3 não tem catch-all nem 404, o
 * resultado é tela BRANCA dentro da casca, sem erro no console.
 */
const breadcrumbsCampanha = { name: 'Campanha da mar.ia', pathName: '/maria/campanha-da-maria', onlyAvailableOnVue2: true }

/**
 * Mesma permissão da rota do v2 (`maria/campanha-da-maria`), idêntica nas cinco rotas do submódulo.
 * Permissão perdida na migração é incidente de segurança, não detalhe de UI.
 *
 * Ela NÃO é a única defesa: a rota `/v3/maria/campanha-da-maria/resultados/:id` também é declarada
 * no host, com `pagePermission`, para que a checagem exista antes de o remote sequer montar. Ver a
 * PR do `mystique`.
 */
const PERMISSAO_CAMPANHA = ['maria/campanha-da-maria']

export default [
  {
    path: '/v3/maria',
    name: 'Maria',
    component: () => import('@/views/BaseRoutingComponent.vue'),
    children: [
      {
        path: 'campanha-da-maria/resultados/:id',
        name: 'results-maria-campaign',
        component: () => import('@/modules/maria/campanha-da-maria/views/pages/ResultadosCampanha.vue'),
        meta: {
          breadcrumbs: [breadcrumbsHome, breadcrumbsMaria, breadcrumbsCampanha, { name: 'Resultados', pathName: null }],
          title: 'Resultados da campanha da mar.ia',
          requiredUserPermissions: PERMISSAO_CAMPANHA,
        },
      },
    ],
  },
]
